<template>
  <div class="rounded-2xl bg-white px-4 py-3" v-bind="$attrs">
    <slot />
  </div>
</template>
